import { Handle, Position, type NodeProps, type Node } from "@xyflow/react";
import { SCHRITT_LABEL } from "@/components/ProcessBits";

// #303 (UC-3): ein Schritt als Knoten. Die Farbe IST die Aussage — wer auf die Karte
// schaut, soll ohne Legende sehen, wo der Lauf steht und wo er hängt.

export interface StepNodeData extends Record<string, unknown> {
  nummer: number;
  label: string;
  status: string;
  aktuell: boolean;
}

const TON: Record<string, { rand: string; flaeche: string; text: string }> = {
  done: { rand: "border-ok-border", flaeche: "bg-ok-bg", text: "text-ok" },
  running: { rand: "border-accent-border", flaeche: "bg-accent-soft", text: "text-accent-text" },
  waiting: { rand: "border-warn-border", flaeche: "bg-warn-bg", text: "text-warn" },
  blocked: { rand: "border-danger-border", flaeche: "bg-danger-bg", text: "text-danger" },
  skipped: { rand: "border-muted-border", flaeche: "bg-muted-bg", text: "text-muted" },
  pending: { rand: "border-border", flaeche: "bg-surface-2", text: "text-text3" },
};

export function StepNode({ data }: NodeProps<Node<StepNodeData>>) {
  const ton = TON[data.status] ?? TON.pending!;
  return (
    <div
      className={`w-[170px] rounded-lg border px-3 py-2 shadow-sm ${ton.rand} ${ton.flaeche} ${
        data.aktuell ? "ring-2 ring-accent-border" : ""
      } ${data.status === "running" ? "animate-pulse" : ""}`}
      data-testid="graph-step-node"
    >
      <Handle type="target" position={Position.Left} className="!opacity-0" isConnectable={false} />
      <div className="flex items-baseline gap-1.5">
        <span className="font-mono text-[10.5px] text-text3">{data.nummer}</span>
        <span className="min-w-0 truncate text-[12.5px] font-semibold text-text" title={data.label}>
          {data.label}
        </span>
      </div>
      <div className={`text-[11px] ${ton.text}`}>{SCHRITT_LABEL[data.status] ?? data.status}</div>
      <Handle type="source" position={Position.Right} className="!opacity-0" isConnectable={false} />
    </div>
  );
}
